const winterdata2022 = [
    {
    "Roll": "17BEC033",
    "Name": "Harsh Girishkumar Prajapati",
    "Project": "Cnn Based Object Detection In Microscopic Image Of Indian Herbal Plants",
    "Guide": "Dr Bhupendra Fataniya",
    "Mail": "harshprajapati4@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/harsh1345/",
    "Report": "https://docs.google.com/document/d/1EL0Zg0g2bpFSzWGJX6yYZGEm0gS-0j30nrSVnuFYKxg/edit?usp=sharing",
    "Tools": "Python Based Programming",
    "Nature": "Research",
    "Website": "https://nirmauni.ac.in/",
    "Description": "In This Project, Detect The Object In The Microscopic Image Of Indian Herbal Plants Using Convolution Neural Network",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "17BEC128",
    "Name": "Yash Jha",
    "Project": "Cnn Based Object Detection In Microscopic Image Of Indian Herbal Plants",
    "Guide": "Dr Bhupendra Fataniya",
    "Mail": "Yash.jha0501@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/yash-jha-a9544b211",
    "Report": "https://docs.google.com/document/d/1dxVIQbf4rr-fwOa6DwZE2P4zvJjuDkmF_p45TwIe0eY/edit?usp=sharing",
    "Tools": "Python Based Programming, Cnn, Image Processing Techniques.",
    "Nature": "Research",
    "Website": "https://nirmauni.ac.in",
    "Description": "In This Project, Detect The Object In The Microscopic Image Of Indian Herbal Plants Using Convolutional Neural Network.",
    "Company": "Other"
    },
    {
    "Roll": "17BEC154",
    "Name": "Lipi Karkar",
    "Project": "Rnd In Complains Of The Costumers",
    "Guide": "Prof. Twinkle Bhavsar",
    "Mail": "lipikarkar8@gmail.com",
    "Linkedin": "no",
    "Report": "https://docs.google.com/document/d/1ZYnxXNt7oy98QKcMsM1y9H5G5yOs1bK9/edit?usp=sharing&ouid=104206803893481943178&rtpof=true&sd=true",
    "Tools": "No",
    "Nature": "Research",
    "Website": "Bharat airtel",
    "Description": "How Complains Come And How To Resolve All The Complains.",
    "Company": "Other"
    },
    {
    "Roll": "18BEC002",
    "Name": "Aashvi Ketak Gajjar",
    "Project": "Intelligent Surveillance And Night Patrolling Using Image Processing",
    "Guide": "Dr Dilip Kothari",
    "Mail": "aashvi3110@gmail.com",
    "Linkedin": "-",
    "Report": "https://docs.google.com/document/d/1G0dYcAgDgo1OczHcW2MIWOAHq59ifeLj/edit?usp=sharing&ouid=103834366043472815622&rtpof=true&sd=true",
    "Tools": "Matlab/Python",
    "Nature": "Simulation",
    "Website": "https://www.dynemixindia.com/",
    "Description": "We Will Be Doing Software Simulations Using Either Matlab Or Python. We Will Be Mainly Focusing On Image Processing And Everything Will Be Based The Application Of That.",
    "Company": "Dynemix India"
    },
    {
    "Roll": "18BEC003",
    "Name": "Abha Mihir Buch",
    "Project": "Cloud Data Integration And Analytics",
    "Guide": "Dr Manish Patel",
    "Mail": "abhabuch@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/abhabuch/",
    "Report": "https://docs.google.com/document/d/15qJgBAN5rolJmRoNNq74U6MwJA9ZHEI_/edit?usp=sharing&ouid=101108900696527661594&rtpof=true&sd=true",
    "Tools": "Aws Cloud Services",
    "Nature": "Experimentation",
    "Website": "https://www.tcs.com/",
    "Description": "Working On Cloud Solutions Using Amazon Web Services (Aws)",
    "Company": "Tata Consultancy Services"
    },
    {
    "Roll": "18BEC004",
    "Name": "Aftaab Alam M Siddiqui",
    "Project": "Digigov Development",
    "Guide": "Dr Ruchi Gajjar",
    "Mail": "aftaab2507@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/aftaabasiddiqui/",
    "Report": "https://docs.google.com/document/d/1axF5lOMQzZIWolC9rtjJ3I7BpKlMrJeWDSSHy9Swcuo/edit?usp=sharing",
    "Tools": "Angular, Spring Boot",
    "Nature": "Product Developement",
    "Website": "https://www.tcs.com/",
    "Description": "Development In The Latest Portal",
    "Company": "Tata Consultancy Services"
    },
    {
    "Roll": "18bec005",
    "Name": "Akanksha Arora",
    "Project": "Not Assigned Yet",
    "Guide": "Dr Nagendra Gajjar",
    "Mail": "akankshaarora129@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/akanksha-arora-3556a9211/",
    "Report": "https://docs.google.com/document/d/1fAAtNUeA8b9GKMVvo2bzGsRgsU5rPKnZa_kuVI1CQ0E/edit?usp=sharing",
    "Tools": "Not Known Yet",
    "Nature": "Product Developement",
    "Website": "https://www.cognizant.com/in/en",
    "Description": "Not Assigned Yet",
    "Company": "Cognizant Technology Solutions India Private Limited"
    },
    {
    "Roll": "18BEC006",
    "Name": "Ambika Vikas Lakhera",
    "Project": "Internship At Infineon Technologies (Cypress Semiconductor)",
    "Guide": "Dr Dilip Kothari",
    "Mail": "ambika.vikas.lakhera@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/ambika-lakhera-a16b5a1a6/",
    "Report": "https://docs.google.com/document/d/1seEzUcSCSX9qV_APfEd0jYLghwa1I9Rfb5h27V-Q5DQ/edit",
    "Tools": "To Be Finalized",
    "Nature": "Experimentation",
    "Website": "https://www.infineon.com/",
    "Description": "To Be Finalized",
    "Company": "Infineon Technologies"
    },
    {
    "Roll": "18BEC007",
    "Name": "Amita Mohta",
    "Project": "Not Given As Of Now",
    "Guide": "Dr Dilip Kothari",
    "Mail": "amita.mohta@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/amita-mohta-815455178/",
    "Report": "https://docs.google.com/document/d/1TRJBsQ6X1nC-jGzJeXfHrLK7nWqVM_Id/edit?usp=sharing&ouid=108209931336353284617&rtpof=true&sd=true",
    "Tools": "Unix, System Verilog",
    "Nature": "Simulation",
    "Website": "https://www.infineon.com/",
    "Description": "Verification Of Cpu Subparts ",
    "Company": "Infineon Technologies"
    },
    {
    "Roll": "18BEC008",
    "Name": "Aravind Kannan",
    "Project": "Estimation Of Aspect Ratio For 2-Stage Operational Amplifier Design",
    "Guide": "Dr Ruchi Gajjar",
    "Mail": "aravindkannan213@gmail.com",
    "Linkedin": "linkedin.com/in/aravind-kannan-162123173",
    "Report": "https://docs.google.com/document/d/1-rJLHfnhWPcCYMIrDu6OmwLz2pScaeVm_2xfpkulM0o/edit?usp=sharing",
    "Tools": "Python, Analog Circuit Design And Simulator Tool (Like Ltspice, Proteus)",
    "Nature": "Experimentation",
    "Website": null,
    "Description": "Aspect Ratio Has Been Estimated Using Ml For Simpler Circuits Like Mos Amplifier. However, This Project Will Try To Implement The Ml Algorithms For More Complicated Circuits Like 2-Stage Op-Amp.",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC009",
    "Name": "Ashu Mittal",
    "Project": "Education Erp",
    "Guide": "Dr Manisha Upadhyay",
    "Mail": "ashumittal847@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/ashu-mittal-034225208/",
    "Report": "https://docs.google.com/document/d/15gQuIqDOr5tNpUug7VhPSQ1ELCPvm5lC1Bx0P2hqhaU/edit?usp=sharing",
    "Tools": "Visual Studio, My Sql Workbench, C-Sharp, Html/Css, Java , Bootstrap, Sql Database, . Net Mvc",
    "Nature": "Product Developement",
    "Website": "http://www.troywings.com/",
    "Description": "Developing A Web-Based Integrated Software For Educational Institutions Similar To Management System",
    "Company": "Troywings Technologies"
    },
    {
    "Roll": "18BEC010",
    "Name": "Atish Kumar Jain",
    "Project": "5G Core Pcf-Bsf Node",
    "Guide": "Prof. Rachna Sharma",
    "Mail": "atishj18700@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/atish-jain-41a562183/",
    "Report": "https://docs.google.com/document/d/12dj68ZPaxHAcTo-Gl5huwVTlNf5iuAWoHj43Eo4EZ10/edit?usp=sharing",
    "Tools": "Java, Kubernetes, Docker, Microservices",
    "Nature": "Product Developement",
    "Website": "https://www.oracle.com/index.html",
    "Description": "Policy Solution For Pcf-Bsf Nodes In 5G Core",
    "Company": "Oracle India Private Limited"
    },
    {
    "Roll": "18BEC013",
    "Name": "Vardhan Vijay Batavia",
    "Project": "Developing Useful Application On Ble Technology",
    "Guide": "Prof. Hardik Joshi",
    "Mail": "bataviavardhan@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vardhann/",
    "Report": "https://docs.google.com/document/d/1xpNCjbPVeRmS4wr1FcsgFnp34ysvN3eq/edit?usp=sharing&ouid=109124140313422406464&rtpof=true&sd=true",
    "Tools": "Ble, C Language, Arduino Ide",
    "Nature": "Product Developement",
    "Website": "https://www.silabs.com/",
    "Description": "Programming Software In C To Build Useful Applications On The Given Soc",
    "Company": "Silicon Labs"
    },
    {
    "Roll": "18BEC014",
    "Name": "Deep Naresh Bhavsar",
    "Project": "Sap Project",
    "Guide": "Dr Piyush Bhatasana",
    "Mail": "rs74295@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/deep-bhavsar-4830721a8/",
    "Report": "https://docs.google.com/document/d/14rfjD4uWu8DBi8f5fPTH6vgQjjkwpmkgrLYv5iZFYGU/edit?usp=sharing",
    "Tools": "Fiori Ui, Sap Abap",
    "Nature": "Product Developement",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Description": "Sap Based Work",
    "Company": "Deloitte India"
    },
    {
    "Roll": "18BEC015",
    "Name": "Vishwam Ketan Bhavsar",
    "Project": "System Level Design And Architecture, Asic Performance Modelling And Simulation/Co-Simulation",
    "Guide": "Dr Bhupendra Fataniya",
    "Mail": "vishwambhavsar@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vishwam-",
    "Report": "https://docs.google.com/document/d/10ZD7r_gQXMVkhyZmm0zW5fxr33eJ0tNo71K3MPOFpIA/edit?usp=sharing",
    "Tools": "Linux, Systemc, Eda Playground, Tlm2",
    "Nature": "Research",
    "Website": "https://www.appliedmaterials.com/",
    "Description": "Architectural Exploration, Transaction Level Modelling, Co-Simulation, Building A Simulator For Performance Modelling And Analysis",
    "Company": "Applied Materials India Private Limited"
    },
    {
    "Roll": "18BEC016",
    "Name": "Hemant Rajkumar Bhojwani",
    "Project": "Validation Of Memory Controller Ips Of Synopsys",
    "Guide": "Dr Sachin Gajjar",
    "Mail": "hemantbhojwani11@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/hemant-bhojwani/",
    "Report": "https://docs.google.com/document/d/1HiYU_IHuq-hyC_GEKUUCA8Kmp7tDAgbYqXIZlWuJ4kA/edit?usp=sharing",
    "Tools": "Linux, Shell Scripting, Tcl, Paultra Tool",
    "Nature": "Product Developement",
    "Website": "https://www.synopsys.com/",
    "Description": "Working On Validating Memory Controller Ips Like Lpddr5 Etc.",
    "Company": "Synopsys"
    },
    {
    "Roll": "18BEC017",
    "Name": "Jigar Dineshbhai Boda",
    "Project": " Holonomic Mobile Robot",
    "Guide": "Dr Akash Mewan",
    "Mail": "jigarpatel71756@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/jigar-boda-5bb3691b0",
    "Report": "https://docs.google.com/document/d/1nUoYSNcCY828x2Ahbd8SGBShJBfeOtZMQ71V2jCRHTc/edit?usp=drivesdk",
    "Tools": "Keil",
    "Nature": "Research",
    "Website": "https://technology.nirmauni.ac.in/campus-life/student-life/robotic-lab/",
    "Description": "Design And Development Of Holonomic Mobile Platform.",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC019",
    "Name": "Chinmaya Mishra",
    "Project": "Professional Trainee",
    "Guide": "Dr Piyush Bhatasana",
    "Mail": "chinmayame10@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/chinmaya-mishra-b28366200",
    "Report": "https://drive.google.com/drive/folders/1Lv2QyWfbVQSh6HCzf7u_PNtSnHn7lOA4?usp=sharing",
    "Tools": "Verilog",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/careers/",
    "Description": "Hardware Design",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC020",
    "Name": "Krutarth Parag Choksi",
    "Project": "Iot Hardware Security",
    "Guide": "Dr Sachin Gajjar",
    "Mail": "krutarthchoksi0801@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/krutarth-choksi-030419179/",
    "Report": "https://docs.google.com/document/d/1KD7TdEBRwmnZMUD_3GVtKri26R_-Q-6gFvE2wkp6XUQ/edit",
    "Tools": "Microsoft Threat Modelling Tool, Raspberry Pi, Arduino",
    "Nature": "Research",
    "Website": "https://nirmauni.ac.in/",
    "Description": "Researching On Different Security Threats In Iot And How To Mitigate Them.",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC021",
    "Name": "Monish Siraj Chunara",
    "Project": "Smart Asset Tracking",
    "Guide": "Dr Akash Mewan",
    "Mail": "monishchunara002@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/monish-chunara-30360a19b/",
    "Report": "https://docs.google.com/document/d/1Uof8epW2GpgrJ1EHfYlU8pH6jq7UnT0Md-Ty8r9v7yw/edit?usp=sharing",
    "Tools": "Iot, Bluetooth (Ble), Beacons, Cloud Computing (Azure), Stm32 Etc.",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/",
    "Description": "The Objective Of The Project Is To Develop A Low-Cost Tracking Solution Using Bluetooth Beacons For Tracking Of Assets And Also To Develop A Mobile Dashboard For The Same.",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC022",
    "Name": "Rutvik Rakeshkumar Dalal",
    "Project": "Smart Dustbin",
    "Guide": "Dr Amisha Naik",
    "Mail": "rutvikdalal.rd@gmail.com",
    "Linkedin": null,
    "Report": "https://drive.google.com/drive/folders/1CS2io-P_fHNOJTkK-oolNQjhduXJElAE",
    "Tools": "Mcu Nodeesp8266, Arduino Ide, Etc",
    "Nature": "Experimentation",
    "Website": null,
    "Description": "To Make A Smart Dustin. ",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC023",
    "Name": "Damini Rajendra Rathi",
    "Project": "Pun Campus Interns",
    "Guide": "Dr Nagendra Gajjar",
    "Mail": "damini.rth@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/damini-rathi-ab01a31b3/",
    "Report": "https://docs.google.com/document/d/1o4Ia3QJvvTh1kJlbGWoXC_tu839KbPII_npJ342OF4E/edit?usp=sharing",
    "Tools": null,
    "Nature": "Product Developement",
    "Website": "https://www.cognizant.com/in/en",
    "Description": null,
    "Company": "Cognizant Technology Solutions India Private Limited"
    },
    {
    "Roll": "18BEC024",
    "Name": "Dave Kanan Prashantkumar ",
    "Project": "Pedestrian Dead Reckoning And Anomaly Detection",
    "Guide": "Dr Dhaval Pujara",
    "Mail": "kanandave11@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/kanan-dave-0b740a183/",
    "Report": "https://docs.google.com/document/d/15iqKJ_IOADkaqKNaJzzOTb2DEH85t7Bs/edit?usp=sharing&ouid=110324376846509630244&rtpof=true&sd=true",
    "Tools": "Python, Iot, Artificial Intelligence And Machine Learning ",
    "Nature": "Simulation",
    "Website": "https://indiannavy.nic.in/",
    "Description": "Creating A Sensor Device To Attract The Data, And Showing The Path Using The Html And Then Applying Artificial Intelligence To The Model ",
    "Company": "Indian Naval Services, Valsura"
    },
    {
    "Roll": "18BEC025",
    "Name": "Devesh Laxminarayan Asawa",
    "Project": "Smart Asset Tracking",
    "Guide": "Dr Amisha Naik",
    "Mail": "deveshasawa999@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/devesh-asawa-2992a8180/",
    "Report": "https://docs.google.com/document/d/14CJ5fYoRnrj14p6ebcecbc483wuEdUOaPcWG5PHWHQs/edit?usp=sharing",
    "Tools": "Stm32 Kit",
    "Nature": "Simulation",
    "Website": "https://www.einfochips.com/",
    "Description": "Create A Low Cost Tracking Solution Using Bluetooth Beacons Based On Ibeacon Or Eddystone Protocols",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC026",
    "Name": "Dhawnil Khandelwal",
    "Project": "Crm",
    "Guide": "Prof. Rachna Sharma",
    "Mail": "dhawnil1999@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/dhawnil-khandelwal-5063701a6",
    "Report": "https://docs.google.com/document/d/1fWrZhQq3m2mLClQY_YqN3LT3BA8puV0DXk5oWiTVFOM/edit?usp=sharing",
    "Tools": "Html, Css, Javascript,Php",
    "Nature": "Product Developement",
    "Website": "https://www.sarvadaksh.com/",
    "Description": "This System Provides An Online Platform To Manage Interactions With Their Customers Or Potential Customers. The System Allows The Customer/Potential Customers To Request A Quotation For The Services They Selected In The System. The System Also Has A Ticketing Feature Which Is Mainly Built To Address The Concerns Of Their Customers. The Customer Can Create Their Tickets For The Issues They Have Encountered And The Management Can Update The Ticket Status From Pending To On-Going Process Or Closed. The System Also Has A Comment Section Feature In Each Ticket In Which The Customer Support And Customer Can Leave A Comment So They Could Discuss The Status And More Details About The Feature.",
    "Company": "Sarvadaksh Event Solutions (Ses)"
    },
    {
    "Roll": "18BEC027",
    "Name": "Divyansh Rai",
    "Project": "Smart Home Automation Control",
    "Guide": "Dr Vijay Savani",
    "Mail": "divyansh.rai00@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/divrai/",
    "Report": "https://docs.google.com/document/d/1hbkcsaFst0r2LK7zw5wTum5SWY5g0p9CVOzmWmtPuCI/edit?usp=sharing",
    "Tools": "Keil, Linux, Gcc",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/",
    "Description": "Create A Home Automation Solution Using Wireless Technology. Home Appliances That Support Wireless Technology Can Be Connected To A Gateway. Use A Micro Controller Evm As Main Controller & Gateway, Which Will Be Controlled Using Local Hmi And Share Information To The Cloud To Control Appliances Remotely As Well.",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18bec028",
    "Name": "Maitry Mehulkumar Dumaswala",
    "Project": "Motionless Camera Capture",
    "Guide": "Dr Bhupendra Fataniya",
    "Mail": "maitrydumas123@gmail.com",
    "Linkedin": "https://in.linkedin.com/in/maitry-dumaswala",
    "Report": "https://docs.google.com/document/d/19K9PEIIjyWvaVqVI6Pdl7NkdMb2Ml-f32vIpJCJ-F8Q/edit?usp=sharing",
    "Tools": "Python",
    "Nature": "Product Developement",
    "Website": "https://nirmauni.ac.in",
    "Description": "Engineer A Motion Capture System Using 4 Or More Cameras Thoroughly Understand And Calibrate Cameras In A Standalone Or Grouped Setup Implement Open Source Projects Such As Freemocap",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC029",
    "Name": "Eshan Saraogi",
    "Project": "Pun Campus Intern",
    "Guide": "Dr Nagendra Gajjar",
    "Mail": "eshansaraogi@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/eshan-saraogi-0792b3180/",
    "Report": "https://drive.google.com/drive/folders/1ntiJWvpvLK4bJ-5mDZUfngKhvXFektSt?usp=sharing ",
    "Tools": null,
    "Nature": "Product Developement",
    "Website": "https://www.cognizant.com/in/en",
    "Description": null,
    "Company": "Cognizant Technology Solutions India Private Limited"
    },
    {
    "Roll": "18BEC030",
    "Name": "Giriraj Singh Chouhan`",
    "Project": "Advanced Lift Contoller",
    "Guide": "Dr Usha Mehta",
    "Mail": "girirajsinghchouhan80@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/giriraj-singh-chouhan-6b2640180",
    "Report": "https://docs.google.com/document/d/1MWvhZy1ejtLl5iBJuCsz3wfYyzYYawG8oXhPm9E6r6E/edit?usp=sharing",
    "Tools": "Verilog, Xilinx Fpga, Quartus, Modelsim",
    "Nature": "Simulation",
    "Website": null,
    "Description": "Design An Advanced Lift Controller And Also Develop Complete Testbench, Along With Do The Hardware Simulation On Fpga",
    "Company": "Inhouse Project"
    },
    {
    "Roll": "18BEC031",
    "Name": "Khushi Xitij Gorasia",
    "Project": "Iot Hardware Security",
    "Guide": "Dr Sachin Gajjar",
    "Mail": "khushigorasia06@gmail.com ",
    "Linkedin": "https://www.linkedin.com/in/khushi-gorasia/",
    "Report": "https://docs.google.com/document/d/1KD7TdEBRwmnZMUD_3GVtKri26R_-Q-6gFvE2wkp6XUQ/edit",
    "Tools": "Microsoft Threat Modelling, Rpi,Arduino",
    "Nature": "Simulation",
    "Website": "https://nirmauni.ac.in/",
    "Description": "To Understand And Implement Threats On Hardware Board And Model It In Simulation",
    "Company": "In-House"
    },
    {
    "Roll": "18BEC033",
    "Name": "Gazal Gupta",
    "Project": "Optical Character Recognition",
    "Guide": "Dr Akash Mewan",
    "Mail": "gazalgupta1120@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/gazal-gupta-5a0237189",
    "Report": "https://docs.google.com/document/d/12R5DQPLyns-AW8tkNUTTsR2Pg-yMYBaC/edit?usp=sharing&ouid=112840486425473976291&rtpof=true&sd=true",
    "Tools": "Machine Learning Using Python",
    "Nature": "Product Developement",
    "Website": "https://visconautomation.com/",
    "Description": "Research And Development On Optical Character Recognition In Pharmaceutical Industry ",
    "Company": "Viscon Automation"
    },
    {
    "Roll": "18BEC034",
    "Name": "Harshil Chetankumar Patel",
    "Project": "Asic Verification Intern",
    "Guide": "Dr Usha Mehta",
    "Mail": "harshilpatel621@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/harshil-patel-07/",
    "Report": "https://docs.google.com/document/d/1z50SZz3BVPxcd6KlB7e1u6bXP5yoMv49F8ZfrajwUNA/edit?usp=sharing",
    "Tools": "Verilog",
    "Nature": "Simulation",
    "Website": "https://www.infinera.com/",
    "Description": "Verification",
    "Company": "Infinera"
    },
    {
    "Roll": "18BEC035",
    "Name": "Harshil Pratikkumar Shah",
    "Project": "Smart Home Automation Control",
    "Guide": "Dr Usha Mehta",
    "Mail": "harshilshahh1@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/harshil-shah-37b28b1ba",
    "Report": "https://drive.google.com/drive/folders/1vZ62fIbvc_htkEoBAHR-RtRYLGwzd-S8",
    "Tools": "Microcontroller Evm",
    "Nature": "Product Developement",
    "Website": "einfochips.com",
    "Description": "Created A Home Automation Solution Using Wireless Technology. Home Appliances That Supports Wireless Technology Can Be Connected To A Gateway. Used A Microcontroller Evm As Main Controller And Gateway, Which Will Be Controlled Locally Using Hmi And Share Information To The Cloud To Control Appliances Remotely As Well.",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC036",
    "Name": "Harshvadan Mihir",
    "Project": "Arduino/Pi Based Operation Control Of Machine/Device.",
    "Guide": "Prof. Rutl Patel",
    "Mail": "harshvadanmihir@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/harshvadan-mihir-056b971b0/",
    "Report": "https://docs.google.com/document/d/1OJQUk8rMgQHMn0n00ZoT49ZZZZW5g4-bxjOtXaH3YZA/edit?usp=sharing",
    "Tools": "Raspberry Pi, Raspbian Os.",
    "Nature": "Product Developement",
    "Website": "http://embeeindia.com/about-us/",
    "Description": "Raspberry Pi Based Control Of A 'Laser Engraving' Machine.",
    "Company": "Embee Group"
    },
    {
    "Roll": "18BEC037",
    "Name": "Hasit Pankaj Trivedi",
    "Project": "Cyber-Security",
    "Guide": "Dr Vaishali Dhare",
    "Mail": "hasittrivedi10@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/hasit-trivedi/",
    "Report": "https://docs.google.com/document/d/1lwBPkq5R3F1qMvqRcfdi2YodLWQTjgUD8Yt0nL6rct0/edit",
    "Tools": "Kali Linux, Burp Suite, Andriod Studio, Genymotion, Pycharm,",
    "Nature": "Experimentation",
    "Website": "https://www.adanienterprises.com/",
    "Description": "Penetration Testing For Mobile And Web Applications",
    "Company": "Adani Enterprises Limited"
    },
    {
    "Roll": "18BEC038",
    "Name": "Helly Mehul Champaneri",
    "Project": "Quality Metrics Generation For Sweepsar Images",
    "Guide": "Dr Manisha Upadhyay",
    "Mail": "hellychampaneri@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/helly-champaneri/",
    "Report": "https://docs.google.com/document/d/1jcN1oyeYLST6OKPDXBoDr-EMUxx25Fww_Fj_Xmx1C_Y/edit?usp=sharing",
    "Tools": "Matlab, Python",
    "Nature": "Research",
    "Website": "https://www.sac.gov.in/Vyom/index.jsp",
    "Description": "Evaluation Of Image Quality Parameters For Sweepsar",
    "Company": "Space Application Centre (Isro)"
    },
    {
    "Roll": "18BEC039",
    "Name": "Miral Ashish Herma",
    "Project": "No Specific Project Assigned",
    "Guide": "Dr Dhaval Shah",
    "Mail": "miral21herma@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/miral-herma-5a0541172/",
    "Report": "https://docs.google.com/document/d/1KSafX41rZe3AWSrYQ8k6nGp64AlGiCjaYzFNH2p3FQE/edit?usp=sharing",
    "Tools": "Canary Mail App And Software, Hubspot, Zendesk",
    "Nature": "Product Developement",
    "Website": "https://canarymail.io/",
    "Description": "Currently Technical Support And Windows Beta Version Testing",
    "Company": "Canary Mail"
    },
    {
    "Roll": "18BEC040",
    "Name": "Ishan Gupta",
    "Project": "Not Given As Of Now",
    "Guide": "Prof. Jayesh Patel",
    "Mail": "ishangupta1601@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/ishan-gupta-ab41b21a0/",
    "Report": "https://docs.google.com/document/d/1HBET4ty8wTtnuqdqtG00h1sF7lX_-aL7tBDuKsK1xVA/edit?usp=sharing",
    "Tools": "System Verilog, Python",
    "Nature": "Simulation",
    "Website": "https://www.infinera.com/",
    "Description": "Verification Related",
    "Company": "Infinera India Pvt. Ltd."
    },
    {
    "Roll": "18BEC041",
    "Name": "Soham Rajeshkumar Jani",
    "Project": "Internship",
    "Guide": "Prof. Rutl Patel",
    "Mail": "soham.jani@outlook.com",
    "Linkedin": "https://in.linkedin.com/in/soham-jani-3244891b2",
    "Report": "https://docs.google.com/document/d/1n2RwamFNRWfSI0Rvq1uaV2KFfxRBBpwG9XH596oSmwI/edit",
    "Tools": "Java, Intellij, Kafka, Rabbitmq, Mongodb, Prostgresql, Redis, Android Studio, Springboot, Spring, Maven, ... ",
    "Nature": "Product Developement",
    "Website": "https://www.quinbay.com/",
    "Description": "Java Backend Programming, Android Ui Development, Springboot Building Websites, Android Apps And Backend For The Same. ",
    "Company": "Quinbay Technologies Pvt Ltd"
    },
    {
    "Roll": "18BEC042",
    "Name": "Jeenang Lalitkumar Shah",
    "Project": "Compiler Tool Chain Development ",
    "Guide": "Dr Nagendra Gajjar",
    "Mail": "jeenangshah1903@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/jeenang-shah/",
    "Report": "https://docs.google.com/document/d/1abgjDP9IpEN_BpnlXhUzGM1zcGgvBHxqvRAmGyF7knE/edit?usp=sharing",
    "Tools": "Linux, Gcc, C++, Python, Perforce, Jira, Confluence",
    "Nature": "Product Developement",
    "Website": "https://www.xilinx.com/",
    "Description": "Working On Different Areas Of Ai Engine Compiler Development (The Exact Specific Area Is Yet Not Assigned)",
    "Company": "Xilinx India Technology Service Private Limited"
    },
    {
    "Roll": "18BEC043",
    "Name": "Pragya Jhala",
    "Project": "Fleet Management",
    "Guide": "Dr Ambika Bhatta",
    "Mail": "pragyajhala26@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/pragya-jhala-8a4278181/",
    "Report": "https://docs.google.com/document/d/1Bpaz9M8l0lRu3Jd6FutMYCwRWUfHrEhh_KiBdqH_S10/edit?usp=sharing",
    "Tools": "Oracle Jdeveloper, Oracle Fusion",
    "Nature": "Product Developement",
    "Website": "https://www.evosysglobal.com/",
    "Description": "Creating Fleet Management Solution For Client Company Which Is0 The Process Of Actively Tracking And Keeping Data Of Where And When The Fleet Is Operating Is Called Fleet Management. Fleet Management System Aims To Reduce The Manual Workload Of Requesting Vehicles, Tracking Employee Requests And Allocation Through The One Stop Solution I.E., Oracle Cloud Fusion Instead Of Another Manual System Solution.",
    "Company": "Evolutionary Systems Pvt. Ltd"
    },
    {
    "Roll": "18BEC044",
    "Name": "Jivansu Nirav Vyas",
    "Project": "Design And Analysis Of Metal Stamp Antennas ",
    "Guide": "Dr Dhaval Pujara",
    "Mail": "jivansu.vyas@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/jivansu-vyas-95a279204",
    "Report": "https://docs.google.com/document/d/1BUl9_dE1Yn_KH3trbCRlljqvSCWGqNE9D3x7-9sqdNQ/edit?usp=sharing",
    "Tools": "Ansys, Hfss ",
    "Nature": "Research",
    "Website": "Securemeters.com",
    "Description": "Design And Analysis Of Metal Stamp Antennas ",
    "Company": "Secure Meters"
    },
    {
    "Roll": "18BEC045",
    "Name": "Neel Nirajbhai Joshi",
    "Project": "Machine Learning For Defense & Military Applications",
    "Guide": "Dr Ruchi Gajjar",
    "Mail": "neeljoshi3110@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/joshi-neel/",
    "Report": "https://docs.google.com/document/d/1OQMbTgDbshf3qh7bixU__w5D8PNsYbaF8vQ9D1HfVks/edit?usp=sharing",
    "Tools": "Python, Jupyter Notebook, Kaggle",
    "Nature": "Research",
    "Website": "https://nirmauni.ac.in/",
    "Description": "One Or More Application Of Machine Learning In The Field Of Defense And Military Application",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC046",
    "Name": "Sanika Mandar Joshi",
    "Project": "Gne Sai Team",
    "Guide": "Prof. Twinkle Bhavsar",
    "Mail": "sanikajoshi1406@gmail.com",
    "Linkedin": "NIL",
    "Report": "https://docs.google.com/document/d/1AlmMMLQRyvVnXo1kEvUWeTLS-MLdEAVfShX_5SqTX0Y/edit",
    "Tools": "Excel, Pyspark, Tableau, Sql, Athena, Python",
    "Nature": "Product Developement",
    "Website": "https://www.zs.com",
    "Description": "Gne Sai",
    "Company": "Zs Associates India Pvt. Ltd."
    },
    {
    "Roll": "18BEC047",
    "Name": "Het Ratilal Kanzariya",
    "Project": "Smart Asset Tracking",
    "Guide": "Prof. Dipesh Panchal",
    "Mail": "hetkanzariya17@gmail.com",
    "Linkedin": "https://in.linkedin.com/in/het-kanzariya-b333b01b5",
    "Report": "https://docs.google.com/document/d/1mRkbfxlQTZK4Cr-TkXDTVx3_2vLl2V7I-xViA0uS3jg/edit?usp=sharing",
    "Tools": " Stm32 Kit",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/",
    "Description": "Create A Low-Cost Tracking Solution Using Bluetooth Beacons Based On Ibeacon Or Eddystone Protocol.",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC048",
    "Name": "Khyat Kamal Patel",
    "Project": "System Level Design, Asic Performance Modelling And Simulation",
    "Guide": "Dr Bhupendra Fataniya",
    "Mail": "khyatpatel417@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/khyat-patel-a07aa41b3/",
    "Report": "https://docs.google.com/document/d/1EqPG12Y8hfSs0-Ai1rMiCgHfgDjqUhaIhFlA00yu7ss/edit?usp=sharing",
    "Tools": "Linuc, Systemc, Tlm",
    "Nature": "Research",
    "Website": "https://www.appliedmaterials.com/",
    "Description": "Transaction Level Modelling, Architecture Exploration, Building A Simulator For Performance Modelling And Analysis",
    "Company": "Applied Materials India Private Limited"
    },
    {
    "Roll": "18BEC049",
    "Name": "Janyae Girish Lahori",
    "Project": "Multi Million Gates Implementation In Physical Design",
    "Guide": "Dr Piyush Bhatasana",
    "Mail": "janyaelahori@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/janyae-lahori-42b2361b2/",
    "Report": "https://docs.google.com/document/d/15vzNS1fVGBRDRJjzGbFbmaGD4vSCOREimAtVilgV2kE/edit?usp=sharing",
    "Tools": "Linux,Tcl, Ic Compiler Synopsys Tool, Prime Time",
    "Nature": "Experimentation",
    "Website": "https://www.einfochips.com/",
    "Description": "Multi Million Gates Implementation In Physical Design",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC050",
    "Name": "Manan Jain",
    "Project": "Mcu Security Application (Dfu For Embedded/Iot System)",
    "Guide": "Dr Dilip Kothari",
    "Mail": "Mananjain2247@gmail.com",
    "Linkedin": "http://www.linkedin.com/in/manan-jain-ece",
    "Report": "https://docs.google.com/document/d/1ibQY2So4erzcUN4p1vy7oEJ_WXNKzVak/edit?usp=sharing&ouid=118318943285779151668&rtpof=true&sd=true",
    "Tools": "C, Embedded C Programming, Arm, Gnu Make",
    "Nature": "Product Developement",
    "Website": "https://www.infineon.com/",
    "Description": "Building And Testing Application (Dfu) On Secured Mcu",
    "Company": "Infineon Technologies"
    },
    {
    "Roll": "18BEC051",
    "Name": "Harsh Mandalaywala",
    "Project": "Machine Learning And Image Processing In Defence",
    "Guide": "Dr Ruchi Gajjar",
    "Mail": "harsh.mandalay@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/harsh-mandalaywala",
    "Report": "https://docs.google.com/document/d/16QfGmPFfttco3KYtS0rozg5pxinI83eT/edit?usp=drivesdk&ouid=110333184528254083348&rtpof=true&sd=true",
    "Tools": "Jupyter Notebook, Kaggle",
    "Nature": "Research",
    "Website": "https://sites.google.com/view/ec-careercare/winter-internship/info?authuser=0",
    "Description": "Image Segmentation And Gan Pix2Pix For Ship Detection, Gunshot Recognition",
    "Company": "Major Project"
    },
    {
    "Roll": "18BEC052",
    "Name": "Viraj Prashant Mankad",
    "Project": "Study Of Wavelets For Interference Detection And Mitigation In Gnss",
    "Guide": "Dr Manisha Upadhyay",
    "Mail": "mankadviraj@gmail.com",
    "Linkedin": "www.linkedin.com/in/viraj-mankad",
    "Report": "https://docs.google.com/document/d/1m3rSJnUsFJ1eD95CBLGzI3EyJLy0DqQIcbMMJiEgDl4/edit?usp=sharing",
    "Tools": "Matlab, Fpga, Verilog ",
    "Nature": "Research",
    "Website": "https://www.isro.gov.in/",
    "Description": "Study And Analysis Of Wavelets And Types Of Wavelets On Matlab. Initial Simulation For Wavelets, And The Interference Detection And Mitigation Process In Gnss Signals In The Software Matlab. If Time Permits, Then The Implementation Of The Interference Detection And Mitigation System On Fpga Will Be Done, After A Proper Result-Oriented Matlab Simulation.",
    "Company": "Space Application Centre (Isro)"
    },
    {
    "Roll": "18BEC053",
    "Name": "Yesha Tushar Masharu",
    "Project": "India Incentive Compensation Implementation Pod",
    "Guide": "Dr Yogesh Trivedi",
    "Mail": "yeshamasharu3010@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/yesha-masharu-7a3a7a192?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BvVHKtDsdTFOIkYwjIg18ag%3D%3D",
    "Report": "https://docs.google.com/document/d/11DX353TgEdHWRrKms5tMp5kfAT4PeefT_Ult7qDrrWw/edit?usp=sharing",
    "Tools": "Javeline Identity Manager(Incentive Manager And Zaidyn Reporting), Sql,Tableau, Python",
    "Nature": "Simulation",
    "Website": "https://www.zs.com/",
    "Description": "It Is Related To Calculating The Incentive Compensation Of Company'S Clients Using Related Tools.",
    "Company": "Zs Associates India Pvt. Ltd."
    },
    {
    "Roll": "18BEC054",
    "Name": "Mayank Shrishdev Ray",
    "Project": "Sap Project",
    "Guide": "Dr Vijay Savani",
    "Mail": "mayankray224@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/mayank-ray/",
    "Report": "https://docs.google.com/document/d/1PZIi71Wojax-aTJkvPPPUT4X3aUm-mttgHtXePcMyLw/edit?usp=sharing",
    "Tools": "Sap Abap , Fiori Ui",
    "Nature": "Product Developement",
    "Website": "www2.deloitte.com",
    "Description": "Sap",
    "Company": "Deloitte India"
    },
    {
    "Roll": "18BEC056",
    "Name": "Vimoli Harshal Mehta",
    "Project": "Employee Productivity Management System",
    "Guide": "Dr Manisha Upadhyay",
    "Mail": "vimolimehta@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vimoli-mehta-1b6985206/",
    "Report": "https://docs.google.com/document/d/1Xo9oY6FCti7J5Y0mOeNm0gX8SKyM7n1VHukrnFSUQnc/edit",
    "Tools": "Python,Opencv, Artificial Intelligence",
    "Nature": "Product Developement",
    "Website": "https://softvan.in/",
    "Description": "Working On A Employee Productivity Monitoringg System",
    "Company": "Softvan Pvt.Ltd"
    },
    {
    "Roll": "18BEC057",
    "Name": "Hardik Sanjaykumar Mistry",
    "Project": "Iot Based Smart Glass",
    "Guide": "Dr Dhaval Pujara",
    "Mail": "mistryhardik9908@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/mistry-hardik-76367b1b5",
    "Report": "https://docs.google.com/document/d/1asQSGRTYdrKTzCeewhS-JWLpXhlA_55IP3LgbA9tG6U/edit?usp=sharing",
    "Tools": null,
    "Nature": "Research",
    "Website": "https://www.indiannavy.nic.in/insvalsura/",
    "Description": "Enhancing Smart Glass Technology ",
    "Company": "Indian Naval Services, Valsura"
    },
    {
    "Roll": "18BEC058",
    "Name": "Mitali Pitliya",
    "Project": "Et&P",
    "Guide": "Dr Vijay Savani",
    "Mail": "mitalipitliya2000@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/mitali-pitliya-0926441b2",
    "Report": "https://docs.google.com/document/d/1WIfJS8DUCdkUkUYGi9xsKg1Q1W9Wb2U12EGHmRgzyWQ/edit",
    "Tools": "Sap",
    "Nature": "Product Developement",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Description": "Costumer Details With Sap Programing ",
    "Company": "Deloitte India"
    },
    {
    "Roll": "18BEC059",
    "Name": "Modi Divy Bhavesh",
    "Project": "Portable Ventilator",
    "Guide": "Dr Sachin Gajjar",
    "Mail": "divymodi1999@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/divy-m-5b9038132/",
    "Report": "https://docs.google.com/document/d/1HYCX73J2oYyt_tiLZktVj8vc4KaWG6I1M79bzzUXW98/edit?usp=sharing",
    "Tools": "Eagle, Kicad, Proteus, Stm32Cubeide, Python",
    "Nature": "Product Developement",
    "Website": "https://oxvi.life/",
    "Description": "Making Schematic By Referring Datasheet, Making Pcb, Do Various Tests On Ventilator So That It Passes The Iec60601 Certification.",
    "Company": "Oxvi"
    },
    {
    "Roll": "18BEC060",
    "Name": "Nair Anoopkumar Anilkumar",
    "Project": "Multi Million Gates Implementation In Design For Testability Or Asic Implementation On Soc Using 28Nm And 16Nm Technology ",
    "Guide": "Dr Piyush Bhatasana",
    "Mail": "nairanoopkumar24@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/anoopkumar-nair-7b72411b6/",
    "Report": "https://docs.google.com/document/d/1Vof_JV1HqL374Wu6GrSWuBl_Lp4qxqhW6Ni-tFsgOkg/edit?usp=sharing",
    "Tools": "Verilog, 16/28Nm Technology, Dft Insertion Techniques",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/",
    "Description": "Will Be Working On 16 Or 28Nm Technology And Building The Dft Around It",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC061",
    "Name": "Nairit Joshi",
    "Project": "Education Erp",
    "Guide": "Dr Manisha Upadhyay",
    "Mail": "ernairitjoshi@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/nairit-joshi-140415180/",
    "Report": "https://docs.google.com/document/d/1FoFvcmIpQdpw8Rj69Q5jl9KTXLNiXrA0Se_MYbV7BrU/edit?usp=sharing",
    "Tools": "Visual Studio, My Sql Workbench, C Sharp, Html, Css, Javascript , Bootstrap, Sql, . Net Mvc",
    "Nature": "Product Developement",
    "Website": "http://troywings.com/",
    "Description": "Developing A Web-Based Integrated Software For Educational Institutions Similar To A Management System.",
    "Company": "Troywings Technologies"
    },
    {
    "Roll": "18BEC062",
    "Name": "Nandan Kirankumar Bhanvadia",
    "Project": "Multi Million Gates Implementation In Design For Testability Or Asic Implementation On Soc Using 28Nm And 16Nm Technology ",
    "Guide": "Dr Dhaval Shah",
    "Mail": "bhanvadianandan@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/nandan-bhanvadia",
    "Report": "https://docs.google.com/document/d/1qwt3wOtJURQb5PJaBTTqdaDMoUdmWnES/edit?usp=sharing&ouid=104474011322483614475&rtpof=true&sd=true",
    "Tools": "Electronics And Digital Design, Verilog, Memory Concepts",
    "Nature": "Product Developement",
    "Website": "www.einfochips.com",
    "Description": "Design For Testability To Be Implemented On 16Nm And 28Nm Technology",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC063",
    "Name": "Gaurav Hamirbhai Nanera",
    "Project": "Multi Million Gates Implementation In Physical Design Or Asic Implementation On Soc Using 28Nm And 16Nm Technology",
    "Guide": "Dr Dhaval Shah",
    "Mail": "ghnanera184@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/gaurav-nanera-02485320b",
    "Report": "https://docs.google.com/document/d/1cJC5wGKX-jxbdrcB5y4CtUg-oI5F_eDD/edit?usp=drivesdk&ouid=110359533876539185834&rtpof=true&sd=true",
    "Tools": "Tcl, Ic Compiler Synopsys Tool, Primetime",
    "Nature": "Experimentation",
    "Website": "https://www.einfochips.com/",
    "Description": "Multi Million Gates Implementation In Physical Design Or Asic Implementation On Soc Using 28Nm And 16Nm Technology ",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC064",
    "Name": "Neel Pankaj Jain",
    "Project": "Scada Developer",
    "Guide": "Dr Ambika Bhatta",
    "Mail": "neeljain821@gmail.com",
    "Linkedin": "neel-jain-087ab1171",
    "Report": "https://docs.google.com/document/d/1SpqEFBr0oZEvlwqMTVqtZmcfCOIUf0OEN76RcInmRwo/edit?usp=sharing",
    "Tools": "Citech",
    "Nature": "Simulation",
    "Website": "http://www.adaptive-engg.com/",
    "Description": "Software Development And Automation Using Scada",
    "Company": "Adaptive Engineering Private Limited"
    },
    {
    "Roll": "18BEC065",
    "Name": "Nishit Dinesh Chechani",
    "Project": "Ui Developement",
    "Guide": "Prof. Twinkle Bhavsar",
    "Mail": "nishitchechani@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/nishit-chechani-b71132208/",
    "Report": "https://docs.google.com/document/d/13Hszm6oc6gX5s5q1ErSfAQuMz0eP7uY4I6wJRHkatDc/edit",
    "Tools": "Javascript,React,D3,Mysql,Node",
    "Nature": "Product Developement",
    "Website": "https://www.accenture.com/in-en",
    "Description": "Building Ui",
    "Company": "Accenture"
    },
    {
    "Roll": "18BEC066",
    "Name": "Nitin Agarwal",
    "Project": "Iot",
    "Guide": "Dr Amisha Naik",
    "Mail": "agarwalnitin953@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/nitin-agarwal-2a947b201",
    "Report": "https://docs.google.com/document/d/1MWvhZy1ejtLl5iBJuCsz3wfYyzYYawG8oXhPm9E6r6E/edit",
    "Tools": "C",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/",
    "Description": "Not Assigned",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC067",
    "Name": "Parin Alpesh Parikh",
    "Project": "Analyzing And Optimizing Silicon Highway For Better Routability",
    "Guide": "Dr Vaishali Dhare",
    "Mail": "parin.parikh10@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/parinparikh10/",
    "Report": "https://docs.google.com/document/d/12b4qOKBOSiSFckIwK-VK6yGotBqpML8BdW_cINg0L1w/edit?usp=sharing",
    "Tools": "Ibmeda, Python, Unix, Git, Tcl",
    "Nature": "Research",
    "Website": "https://www.ibm.com/in-en",
    "Description": "Analyze And Optimize The Highway Insertion In Terms Of Timing And Congestion Varying Their Proportion, Thickness, Etc.",
    "Company": "Ibm"
    },
    {
    "Roll": "18BEC068",
    "Name": "Bhoomi Parmar",
    "Project": "Yet To Be Assigned",
    "Guide": "Dr Akash Mewan",
    "Mail": "parmarbhoomi81@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/bhoomi-parmar-19a51a1a0/",
    "Report": "https://docs.google.com/document/d/10WTYZXhzoNl0YhCvAQ6ngTWpfedzayITzT2igV6ZVOk/edit?usp=sharing",
    "Tools": null,
    "Nature": "Product Developement",
    "Website": "https://www.cognizant.com/in/en",
    "Description": null,
    "Company": "Cognizant Technology Solutions India Private Limited"
    },
    {
    "Roll": "18BEC069",
    "Name": "Sanjaykumar Jashvantbhai Parmar",
    "Project": "Design And Implementation Of Iot Security Algorithm",
    "Guide": "Dr Nagendra Gajjar",
    "Mail": "sanjayparmar2402@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/sanjay-parmar-a30b82170/",
    "Report": "https://docs.google.com/document/d/1GR_kjRctVNFL4R_lnRS8m-yQksMFuX5sSKwlUww7T4E/edit?usp=sharing",
    "Tools": "R-Pi, Zigbee, Qemu, Python, C",
    "Nature": "Simulation",
    "Website": "https://technology.nirmauni.ac.in/",
    "Description": "To Build A System Around R-Pi Board For Wireless Transmission And Reception Of The Information Using Zigbee Protocol. For The Implementation Of Added Security In Transmission The Encryption And Decryption Algorithm Is Implemented At Transmitter And Receiver Respectively. ",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC071",
    "Name": "Bhavin Kanubhai Patel",
    "Project": "Smart Asset Tracking ",
    "Guide": "Dr Akash Mewan",
    "Mail": "Bhavinpatel11009@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/bhavin-patel-07a24b1b0/",
    "Report": "https://docs.google.com/document/d/1DLQ6MBDVBK0GKXlXX0lnD4Js1Nit6Rb-Afeb-qDwHQY/edit?usp=sharing",
    "Tools": "Stm32 Kit, Ble Apis, Azure Cloud ",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/",
    "Description": "Create A Low Cost Tracking Solution Using Bluetooth Beacons On Ibeacon Or Eddystone Protocol ",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC072",
    "Name": "Daxal Girishbhai Patel",
    "Project": "Implementation Of G.729A On Risc-V Processor",
    "Guide": "Dr Sachin Gajjar",
    "Mail": "daxalpatel2372@gmail.com",
    "Linkedin": "www.linkedin.com/in/daxal-patel-4bb009181",
    "Report": "https://docs.google.com/document/d/1DH0kt11KxhCgwpRvgVIj0enRcszdK4hWlZUtwko3paM/edit?usp=sharing",
    "Tools": "Softconsole, Libero Soc, Verilog, Vhdl, Risc V Compiler, Matlab, Simulink",
    "Nature": "Research",
    "Website": "https://www.sac.gov.in/Vyom/index.jsp",
    "Description": "I Have To Implement G.729A Audio Processing Standard On Risc V Based Fpga.",
    "Company": "Space Application Centre (Isro)"
    },
    {
    "Roll": "18BEC075",
    "Name": "Vandit Mayurbhai Prajapati ",
    "Project": "Smart Home Automation Control",
    "Guide": "Prof. Jayesh Patel",
    "Mail": "vanditp20@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vandit-m-prajapati/",
    "Report": "https://docs.google.com/document/d/1g0pSUw06deeFouvEMSQz3nzAGG4pBV4tEi4hxvKfL0c/edit?usp=sharing",
    "Tools": "Embedded C, Linux, Microcontroller",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/",
    "Description": "Create A Home Automation Solution Using Wireless Technology. Home Appliances That Supports Wireless Technology Can Be Connected To A Gateway. Use A Micro Controller Evm As Main Controller & Gateway, Which Will Be Controlled Locally Using Local Hmi And Share Information To The Cloud To Control Appliances Remotely As Well.",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18bec077",
    "Name": "Pranav Singh",
    "Project": "Sap Project",
    "Guide": "Dr Piyush Bhatasana",
    "Mail": "pranavsingh0507@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/pranav-singh-b291301b4",
    "Report": "https://docs.google.com/document/d/10xQPNGEP22R0S-ngM6gj6vlwUk0d2bL1hJ0ttSqdAr8/edit?usp=sharing",
    "Tools": "Sap Abap,Fiori Ui",
    "Nature": "Product Developement",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Description": "Sap",
    "Company": "Deloitte India"
    },
    {
    "Roll": "18BEC078",
    "Name": "Pranit Soni",
    "Project": "Fleet Management",
    "Guide": "Prof. Hardik Joshi",
    "Mail": "pranitsoni1999@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/pranit-soni-b5b00a181/",
    "Report": "https://docs.google.com/document/d/1nt1C4Tb78w1JJtCEcWsTQ0o8fButluj20WHVFc67dw0/edit?usp=drivesdk",
    "Tools": "Oracle Jdeveloper, Oracle Fusion",
    "Nature": "Product Developement",
    "Website": "https://www.evosysglobal.com/",
    "Description": "Fleet Management Is A Process Of Actively Tracking And Keeping Data Of Where And When The Fleet Is Operating Is Called Fleet Management. Fleet Management System Aims To Reduce The Manual Workload Of Requesting Vehicle'S, Tracking Employee Request And Allocation Through The One Stop Solution I.E., Oracle Cloud Fusion Instead Of Other Manual System.",
    "Company": "Evolutionary Systems Pvt. Ltd"
    },
    {
    "Roll": "18bec079",
    "Name": "Prateek Pandya",
    "Project": "Yet To Be Assigned",
    "Guide": "Dr Akash Mewan",
    "Mail": "prateek786pandya@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/prateek-pandya-02b149176",
    "Report": "https://docs.google.com/document/d/109t47fuyOfkT0TbSd5AShcjSKWOdS9fA1ppgkK9jcdc/edit?usp=sharing",
    "Tools": "Yet To Be Assigned",
    "Nature": "Product Developement",
    "Website": "https://www.cognizant.com/in/en",
    "Description": "Yet To Be Assigned",
    "Company": "Cognizant Technology Solutions India Private Limited"
    },
    {
    "Roll": "18BEC080",
    "Name": "Priyansh Jain",
    "Project": "Automation Of Competitive Data Page",
    "Guide": "Dr Dhaval Shah",
    "Mail": "priyanshjain602@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/priyansh-jain-943005181",
    "Report": "https://docs.google.com/document/d/16KCApbQJQ4-hB3G9Iy_s34NKgIwfz803ZzHe9o5LHs0/edit?usp=sharing",
    "Tools": "Shell Script, Python Script, Html, Css, Javascript",
    "Nature": "Experimentation",
    "Website": "https://www.xilinx.com/",
    "Description": "Create Or Update Competitive Data Analysis Webpage Based On Data From *.Xlsx/*.Csv/*.Json Files Using Some Scripting Language (Python Scripting In My Case).",
    "Company": "Xilinx India Technology Service Private Limited"
    },
    {
    "Roll": "18BEC081",
    "Name": "Pulkit Suresh Devpura",
    "Project": "Internship Trainee",
    "Guide": "Prof. Dipesh Panchal",
    "Mail": "pulkitdevpura2806@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/pulkitdevpura/",
    "Report": "https://docs.google.com/document/d/1plbAMzeub-txy6HofSeXIzDi3AZ7z3D4/edit?usp=sharing&ouid=112756296460557963033&rtpof=true&sd=true",
    "Tools": "Cadence Innovus ",
    "Nature": "Product Developement",
    "Website": "https://www.microcircuits.in/",
    "Description": "Physical Design ",
    "Company": "Microcircuits Technology"
    },
    {
    "Roll": "18BEC082",
    "Name": "Raghav Devendra Lakhotia",
    "Project": "Associate Functional Consultant Intern. Project - Fleet Management",
    "Guide": "Dr Ambika Bhatta",
    "Mail": "raghav.d.dl@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/raghav-maheshwari-8a494a21b/",
    "Report": "https://docs.google.com/document/d/1TuJFxoP_hgB4L7QgoZomdu8o5PqwK_sCOYbYP7g1omg/edit?usp=sharing",
    "Tools": "Oracle Fusion Software As A Service (Saas)Application",
    "Nature": "Product Developement",
    "Website": "https://www.evosysglobal.com/",
    "Description": "Getting Trained On Oracle Fusion Which Is A Software As A Service Application Of Oracle. Post Which Will Be Working On Project",
    "Company": "Evolutionary Systems Pvt. Ltd"
    },
    {
    "Roll": "18BEC083",
    "Name": "Divyesh Himmatbhai Ranpariya",
    "Project": "Auto Generation Of Code Coverage Exclusions For Soc Clocks Design",
    "Guide": "Dr Sachin Gajjar",
    "Mail": "divyeshranpariya23@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/divyesh-ranpariya-b367a6173",
    "Report": "https://docs.google.com/document/d/1tkRKVel2YohASxD6Z7CcLRPpJcoAwCM6/edit?usp=sharing&ouid=101299200473689999707&rtpof=true&sd=true",
    "Tools": "Centos, System Verilog, Perl, Perforce, Cpp, Verdi Tool (Synopsys)",
    "Nature": "Experimentation",
    "Website": "https://www.nvidia.com/en-in/",
    "Description": "Deals With Coverage Optimization For Soc Verification Performance Enhancement",
    "Company": "Nvidia"
    },
    {
    "Roll": "18BEC084",
    "Name": "Varshi Rathi",
    "Project": "Completion Of Certification As Associate Cloud Engineer & It'S Practical Application In Cloud Technology",
    "Guide": "Dr Ambika Bhatta",
    "Mail": "varshimrathi17@gmail.com",
    "Linkedin": "www.linkedin.com/in/varshirathi17",
    "Report": "https://docs.google.com/document/d/1D219DpBXNStB6TXhB_59rB62Zi560hViDZkXZrwdHR0/edit?usp=sharing",
    "Tools": "Google Cloud Platform",
    "Nature": "Entrepreneurship",
    "Website": "https://searce.com/",
    "Description": "Leveraging Business To Cloud Platform",
    "Company": "Searce Cosourcing Services Pvt. Ltd."
    },
    {
    "Roll": "18BEC085",
    "Name": "Revant Nirav Lala",
    "Project": " Design And Implementation Of Digital Circuit Using Nanotechnology",
    "Guide": "Dr Vaishali Dhare",
    "Mail": "revantlala@gmail.com",
    "Linkedin": "linkedin.com/in/revant-lala",
    "Report": "https://docs.google.com/document/d/1ggCn6LvvADpYo9GPXz4f7vlP7MJezedQpxzm5Ti85PA/edit?usp=sharing",
    "Tools": "Qcadesigner",
    "Nature": "Simulation",
    "Website": "www.nirmauni.ac.in",
    "Description": "Designing Digital Circuit Using Quantum Based Devices, Reversible Technology. (Modern Vlsi) ",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC086",
    "Name": "Rhea Satwindersingh Sansowa",
    "Project": "Business Technology Intern",
    "Guide": "Dr Yogesh Trivedi",
    "Mail": "rhea.s.sansowa@gmail.com ",
    "Linkedin": "https://www.linkedin.com/in/rhea-sansowa-60177016a/",
    "Report": "https://drive.google.com/drive/folders/1HMv3kHuvx8xz5ku53JRNfVUwXZOXZaxI?usp=sharing",
    "Tools": "Sql, Tableau",
    "Nature": "Simulation",
    "Website": "https://www.zs.com/",
    "Description": null,
    "Company": "Zs Associates India Pvt. Ltd."
    },
    {
    "Roll": "18BEC087",
    "Name": "Rishika Manoj Patwa",
    "Project": "Data Analytics",
    "Guide": "Dr Yogesh Trivedi",
    "Mail": "rishikapatwa21@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/rishika-patwa-1251b61b",
    "Report": "https://docs.google.com/spreadsheets/d/1k8uUisvx0017tlj3XAWjcTRxOl5o1HDblC1-kENSHqk/edit?usp=sharing_eil_m&ts=61e9118b",
    "Tools": "Excel, Sql, Jim",
    "Nature": "Product Developement",
    "Website": "https://www.zs.com/",
    "Description": "Data Analytics For A Pharma Client",
    "Company": "Zs Associates India Pvt. Ltd."
    },
    {
    "Roll": "18BEC088",
    "Name": "Rishita Malhotra",
    "Project": "Energy Detection Using Usrp Board",
    "Guide": "Dr Yogesh Trivedi",
    "Mail": "18rishitamalhotra@gmail.com",
    "Linkedin": "nkedin.com/in/rishita-malhotra-3a09061a9/",
    "Report": "https://docs.google.com/document/d/1Cz4N-r1SaMkFEqPxu6sMxmttchjVDEXnddUljEtRaW8/edit",
    "Tools": "Labview Software, Matlab, Usrp Kit",
    "Nature": "Research",
    "Website": "https://nirmauni.ac.in/",
    "Description": "The Major Objective Of This Project Is To Learn About The Recent Trends Is Wireless Communication And Also More Specifically Explore The Domain Of Cognitive Radio And Spectrum Sensing Technology",
    "Company": "Nirma University"
    },
    {
    "Roll": "18BEC089",
    "Name": "Ritik Garg",
    "Project": "Wifi Development ",
    "Guide": "Prof. Dipesh Panchal",
    "Mail": "ritikgarg0035@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/ritik-garg-31003a171/",
    "Report": "https://docs.google.com/document/d/1fDyFnUIRNSJkJyd5EvADFOgA439jlKkfM8gee2Y3cFI/edit?usp=sharing",
    "Tools": "Linux, Wifi, Vscode",
    "Nature": "Product Developement",
    "Website": "https://www.infineon.com/",
    "Description": "Developing Driver For Wifi",
    "Company": "Infineon Technologies"
    },
    {
    "Roll": "18BEC090",
    "Name": "Hard Siddharth Rokad",
    "Project": "Data Stewardship",
    "Guide": "Prof. Twinkle Bhavsar",
    "Mail": "hard.rokad@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/hard-rokad-60758b1b0/",
    "Report": "https://docs.google.com/document/d/1POYx44a2hBXcWI0aAW1g3F9zB_sM5TCatjsGoOiG0dk/edit",
    "Tools": "Sql, Python, Tableaue",
    "Nature": "Product Developement",
    "Website": "https://www.zs.com/",
    "Description": "Data Stewardship ",
    "Company": "Zs Associates India Pvt. Ltd."
    },
    {
    "Roll": "18BEC091",
    "Name": "Taman Pradeep Sachanandani ",
    "Project": "Fleet Managment",
    "Guide": "Prof. Jayesh Patel",
    "Mail": "taman.sachanandani00@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/taman-sachanandani-915a63209",
    "Report": "https://docs.google.com/document/d/1GfD4PpOC_cP0SGAZKAxrPXpTVppwv-dZYSj9CZ3K-EA/edit?usp=sharing",
    "Tools": "Oracle Jdeveloper, Oracle Fusion ",
    "Nature": "Research",
    "Website": "https://www.evosysglobal.com/",
    "Description": " The Process Of Actively Tracking And Keeping Data Of Where And When The Fleet Is Operating Is Called Fleet Management. Fleet Management System Aims To Reduce The Manual Workload Of Requesting Vehicles, Tracking Employee Requests And Allocation Through The One Stop Solution I.E., Oracle Cloud Fusion Instead Of Another Manual System Solution. ",
    "Company": "Evolutionary Systems Pvt. Ltd"
    },
    {
    "Roll": "18BEC092",
    "Name": "Sakshi Sumit Agarwal",
    "Project": "Fleet Management",
    "Guide": "Dr Ambika Bhatta",
    "Mail": "sakshiagrawal0704@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/sakshi-agrawal-81467616a",
    "Report": "https://docs.google.com/document/d/1ZyFwCIOmU1WesP29W9SZ88WZb8FIJ52Kb3NCTCR3nw8/edit?usp=sharing",
    "Tools": "Oracle Jdeveloper, Oracle Fusion",
    "Nature": "Research",
    "Website": "https://www.evosysglobal.com/",
    "Description": "The Process Of Actively Tracking And Keeping Data Of Where And When The Fleet Is Operating Is Called Fleet Management. Fleet Management System Aims To Reduce The Manual Workload Of Requesting Vehicles, Tracking Employee Requests And Allocation Through The One Stop Solution I.E., Oracle Cloud Fusion Instead Of Another Manual System Solution.",
    "Company": "Evolutionary Systems Pvt. Ltd"
    },
    {
    "Roll": "18BEC093",
    "Name": "Samaksh Mittal",
    "Project": "Transcripts And Progress Report For Students",
    "Guide": "Prof. Hardik Joshi",
    "Mail": "sam.mittal44@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/samaksh-mittal-967447168/",
    "Report": "https://drive.google.com/drive/folders/1cZppkL7F9O-NNKFqLBZXADqix8B5i_V-?usp=sharing",
    "Tools": "React.Js, Graphql, Apollo, Redux, Html, Scss",
    "Nature": "Product Developement",
    "Website": "https://web.toddleapp.com/?type=loginHome&utm_source=website",
    "Description": "To Develop And Enhance The Frontend For The Webplatform From The Given Design,Debugging Bugs, Drafting Documentation For The Same",
    "Company": "Toddle"
    },
    {
    "Roll": "18bec094",
    "Name": "Samarth Garg",
    "Project": "Real Time Cash Circulation",
    "Guide": "Dr Usha Mehta",
    "Mail": "samarth.garg233@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/samarth-garg-88b1081a0?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BvakVh0NkQMe9hOwQKK3dsA%3D%3D",
    "Report": "https://docs.google.com/document/d/1VMudlNNlu9SZw_8uCkk0HX-y0XnQythN/edit?usp=sharing&ouid=104709677288516872782&rtpof=true&sd=true",
    "Tools": "Core Java",
    "Nature": "Product Developement",
    "Website": "https://www.statestreet.com",
    "Description": "Design Technology For Real Time Cash Circulation",
    "Company": "State Street Corporation"
    },
    {
    "Roll": "18BEC095",
    "Name": "Sanskriti Mishra",
    "Project": "Data Visualization For A Bank In Saudi Arabia",
    "Guide": "Dr Bhupendra Fataniya",
    "Mail": "sanskritimishra10@gmal.com",
    "Linkedin": "https://www.linkedin.com/in/sanskriti-mishra-7261a3199/",
    "Report": "https://drive.google.com/drive/folders/1bRJJX92480HOsNX5temcO6mU-lT3Ycyy?usp=sharing",
    "Tools": "Oracle, Tableau ",
    "Nature": "Product Developement",
    "Website": "https://www.effiya.com/",
    "Description": "Creating A Company'S Dashboard As Per The Requirements",
    "Company": "Effiya Technologies"
    },
    {
    "Roll": "18BEC096",
    "Name": "Sarthak Farkya",
    "Project": "Backend Development For Health Application",
    "Guide": "Dr Ruchi Gajjar",
    "Mail": "sarthakfarkya1234@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/sarthak-farkya-13049716a",
    "Report": "https://docs.google.com/document/d/1wyglkfWXQlEvarpQp3kc4fItBsySrv75mr7kzpBVf4s/edit?usp=sharing",
    "Tools": "Mongodb, Express, Node, Docker",
    "Nature": "Product Developement",
    "Website": "https://infocusp.in/",
    "Description": "Making Different Api'S And Working On Backend Development Of Application",
    "Company": "Infocusp Innovations Pvt Ltd"
    },
    {
    "Roll": "18BEC097",
    "Name": "Saumya Tejas Shah",
    "Project": "Smart Dustbin",
    "Guide": "Dr Amisha Naik",
    "Mail": "stshah2000@gmail.com",
    "Linkedin": "www.linkedin.com/in/saumya-shah-85872316b",
    "Report": "https://docs.google.com/document/d/1uyxntXnDbwlDlBEUGKwoU9J4RUu2E0auDcOZmHPlQCo/edit?usp=sharing",
    "Tools": "Keil, Arduino Ide, Proteus/Tinkercad",
    "Nature": "Research",
    "Website": "nirmauni.ac.in",
    "Description": "Improving The Existing Design And Adding Features To Smart Dustbin",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC098",
    "Name": "Heli Hetalbhai Shah",
    "Project": "Development Of General Purpose Configurable Ip Cores For On Board Development",
    "Guide": "Dr Dhaval Pujara",
    "Mail": "helihshah@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/heli-shah-1b2261207/",
    "Report": "https://docs.google.com/document/d/1xoOxj9Nv9HRnYlFugfYMwvc6vUoXWaNyYtMrcebteeY/edit",
    "Tools": "Verilog, System Verilog",
    "Nature": "Research",
    "Website": "https://www.isro.gov.in/",
    "Description": "For The Commonly Used Modules Like Memory Controller, Adc Etc. Everyone Design The Code Individually. In-Order To Avoid The Duplication Of Code Here We Are Trying To Design The General Purpose Ip Cores From The Configurable Parameters. ",
    "Company": "Sac-Isro"
    },
    {
    "Roll": "18BEC099",
    "Name": "Purvansh Shetal Shah",
    "Project": "Quantitative Analysis Of Indian Derivatives Market",
    "Guide": "Dr Manish Patel",
    "Mail": "purvansh11@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/purvansh-shah/",
    "Report": "https://docs.google.com/document/d/1kOYA5SrAqdr3IsBmFfCMAjT063OKU5eJ2XCIoEe3Uv0/edit?usp=sharing",
    "Tools": "Python",
    "Nature": "Product Developement",
    "Website": "https://iragecapital.com/",
    "Description": "Advancement In Money Making Algorithms In Indian Stock Market To Directly Increase Revenue Of The Firm",
    "Company": "Irage Broking Services Llp"
    },
    {
    "Roll": "18BEC100",
    "Name": "Yashasvi Girishbhai Shah",
    "Project": "Multi Million Gates Implementation In Dft Or Asic Implementation Of Soc Using 28 Nm And 16Nm Technology ",
    "Guide": "Dr Vijay Savani",
    "Mail": "shahyashasvi2711@gmail.com ",
    "Linkedin": "https://www.linkedin.com/in/yashasvi-shah-2973991a5",
    "Report": "https://docs.google.com/document/d/168blkSBGynW6omdOcWK6HrecTAuAb4aWwyEoQYqTPq0/edit?usp=drivesdk",
    "Tools": "Linux, Perl, Verilog, Icarus",
    "Nature": "Simulation",
    "Website": "https://www.einfochips.com/",
    "Description": "Multi Million Gates Implementation In Dft Or Asic Implementation Of Soc Using 28 Nm And 16Nm Technology ",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC101",
    "Name": "Shivam Kapildev Pandey",
    "Project": "Smart Asset Tracking",
    "Guide": "Prof. Dipesh Panchal",
    "Mail": "shivam3523pandey@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/shivam-pandey-389952182/",
    "Report": "https://docs.google.com/document/d/1pZwXl6MQmFcZpjejZ3kfMxgHTw0yzf-R/edit?usp=sharing&ouid=114663916708039609752&rtpof=true&sd=true",
    "Tools": "Stm32, Iot, Cloud, Mcu, Beacon",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/",
    "Description": "Smart Asset Tracking Create A Low-Cost Tracking Solution Using Bluetooth Beacons Based On Ibeacon Or Eddystone Protocol. Use Stm32 Kit As Iot Gateway And This Gateway Will Scan The Nearby Ble Beacons And Their Rssi Values. Capture The Beacon List And Share That To The Cloud. Visualize This List On The Mobile Application. Here Beacons Will Represent The Assets Like Parcels For Logistic Company, Cars Or Car Keys For The Car Dealers Use Case. Using Ble Apis Run Ble Scan At Given Frequency (Every 5 Minute) For (30 Second Window) And Capture The Scan List Along With Beacons Rssi Values. Register Stm32 Kit As Iot Gateway With Azure Cloud. Share The Scan List To Cloud Every 5 Minutes. On Mobile Application Get The Scan List And Display The Beacons And Rssi Values To Track The Assets",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18bec102",
    "Name": "Shivam Shukla",
    "Project": "Backend Developer Infor",
    "Guide": "Dr Manish Patel",
    "Mail": "shivamshukla752@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/shivam-shukla-30ba771b7/",
    "Report": "https://docs.google.com/document/d/1XMfVqznr95XWE15OELxPfxiTLogqMX6z5R6x9Mrh_wI/edit?usp=sharing",
    "Tools": "Git, Selenium, Java, Splunk, Jira, Angular, Javascript, Html, Css, Nodejs, Mongo",
    "Nature": "Product Developement",
    "Website": "https://www.infor.com/",
    "Description": "Working On Server Side Of The Product (Birst) And Also Working On Selenium Testing Using Java",
    "Company": "Infor Global Solutions India Pvt Ltd"
    },
    {
    "Roll": "18bec104",
    "Name": "Anuj Shukla",
    "Project": "Data Stewardship",
    "Guide": "Prof. Twinkle Bhavsar",
    "Mail": "sanuj1321@gmail.com",
    "Linkedin": "linkedin.com/in/anuj-shukla-8b177516a",
    "Report": "https://docs.google.com/document/d/1D9Y7fszaS4v2n1StQt6ngzaIHXlZozQjWtbrhvWwyeE/edit?usp=sharing",
    "Tools": "Python , Excel ",
    "Nature": "Product Developement",
    "Website": "https://www.zs.com/",
    "Description": "Data Stewardship",
    "Company": "Zs Associates India Pvt. Ltd."
    },
    {
    "Roll": "18BEC105",
    "Name": "Parjanya Rakeshbhai Shukla",
    "Project": "Electronics And Iot",
    "Guide": "Dr Ambika Bhatta",
    "Mail": "parjanyashukla.ps@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/parjanyashukla",
    "Report": "https://docs.google.com/document/d/1aunZWS709vxwMGB_uGqoWDbRDaE-8moDKo_p4LZxNBE/edit?usp=sharing",
    "Tools": "C++, Freertos, Nodered",
    "Nature": "Research",
    "Website": "https://www.zaubacorp.com/company/URBANPOD-INNOVATION-PRIVATE-LIMITED/U28999GJ2020PTC114763",
    "Description": "Would Be Doing The Electronics Section Of Pcb Designing And Firmware Developing. Also, Dealing With The Iot Integrating Cloud.",
    "Company": "Urbanpod Innovation Private Ltd."
    },
    {
    "Roll": "18BEC106",
    "Name": "Shwet Upadhyay",
    "Project": "Revenue Optimization For Hotels",
    "Guide": "Prof. Rachna Sharma",
    "Mail": "shwet171099@gmail.com",
    "Linkedin": "www.linkedin.com/in/shwet-upadhyay-80b5b4155",
    "Report": "https://docs.google.com/document/d/1yAYPe4hJ2hSum5VTEXunTNZb5lQwsG1PvmVbKYCKNfM/edit?usp=sharing",
    "Tools": "Python, Tensorflow, Keras",
    "Nature": "Experimentation",
    "Website": "https://www.ezeetechnosys.com/",
    "Description": "Using Deep Learning For Predicting Prices",
    "Company": "Ezee Technosys Pvt Ltd"
    },
    {
    "Roll": "18BEC107",
    "Name": "Siddhant Gaurav Patel",
    "Project": "Software Development For Client Using Java",
    "Guide": "Prof. Hardik Joshi",
    "Mail": "siddhantgpatel01@gmail.com",
    "Linkedin": "www.linkedin.com/in/siddhantgpatel",
    "Report": "https://docs.google.com/document/d/1yc_0V5VjezfAmT72xxuphpqAdSO6RlLZN-RIqetwfZY/edit?usp=sharing",
    "Tools": "Java",
    "Nature": "Product Developement",
    "Website": "https://musikaar.com/",
    "Description": "Assisting Company Guide On Project Development For Client Using Java And Web Api",
    "Company": "Musikaar"
    },
    {
    "Roll": "18BEC108",
    "Name": "Kshitij Singh",
    "Project": " Optimization Of Industrial Plants",
    "Guide": "Dr Manish Patel",
    "Mail": "kshitijsingh01@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/kshitij-singh-a054801b3/",
    "Report": "https://docs.google.com/document/d/1DbZZ43RWkMjzDBiyBq1o-5pZXpHeE232yyGdfBu7mCE/edit?usp=sharing",
    "Tools": "Python, Aws(Sagemaker)",
    "Nature": "Product Developement",
    "Website": "https://infocusp.in/",
    "Description": "Using Ml Models To Optimize Chemical And Energy Consumption In Industrial Plants",
    "Company": "Infocusp Innovations Pvt Ltd"
    },
    {
    "Roll": "18BEC109",
    "Name": "Mihir Kapil Soni",
    "Project": "Fraud Management And Investigation Solution",
    "Guide": "Dr Ruchi Gajjar",
    "Mail": "mihirksoni@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/mihirksoni/",
    "Report": "https://docs.google.com/document/d/1uYwPi_HYvi0eZYSISbkOWllfiij-_5Yb5j7OrlnGasY/edit?usp=sharing",
    "Tools": "Sas Visual Investigator ",
    "Nature": "Product Developement",
    "Website": "https://www.effiya.com/",
    "Description": "Developing An Environment For Detection, Investigation And Case Management Of Fraud For A Bank Using Sas Vi",
    "Company": "Effiya Technologies"
    },
    {
    "Roll": "18BEC110",
    "Name": "Shubham Vikas Soni",
    "Project": "Byte Etl Tool",
    "Guide": "Dr Ruchi Gajjar",
    "Mail": "sonishubham.v@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/shubhamsoni1/",
    "Report": "https://docs.google.com/document/d/1-SknRw2uSR2GWZUuJ8_2qMBuINIPc_6IFO4O_rhhhhE/edit?usp=sharing",
    "Tools": "React.Js, Node.Js, D3.Js, Mysql",
    "Nature": "Product Developement",
    "Website": "www.accenture.com",
    "Description": "Byte Etl Tool Will Be A User-Friendly Gui Tool, That Helps Users To Integrate All The Three Process (Extract ,Transform And Load) Into A Single Application More Effectively. It Will Help To Develop And Deploy Data Integration Jobs Faster Than Hand Coding. This Will In Turn Minimize The Code And Replace It With Components That Will Have Drag And Drop Functionality In Gui. It Will Be Integrated With The B2B Data Analytics Platform Created By The Company.",
    "Company": "Accenture"
    },
    {
    "Roll": "18BEC111",
    "Name": "Vedant Kamleshbhai Sukhadia",
    "Project": "Research Based",
    "Guide": "Prof. Jayesh Patel",
    "Mail": "sukhadiavedant0726@gmail.com ",
    "Linkedin": "https://www.linkedin.com/in/vedant-sukhadia-b53226171",
    "Report": "https://docs.google.com/document/d/1gpmDGlGDwxPJJzrvxPb8rbgoZ6Ei0Smqb-wZfDUW7qU/edit?usp=sharing",
    "Tools": "Python, Rstudio",
    "Nature": "Research",
    "Website": "http://www.basesolveinformatics.com/",
    "Description": "Researching In The Fields Of Data",
    "Company": "Basesolve"
    },
    {
    "Roll": "18BEC112",
    "Name": "Suyash Anil Malik",
    "Project": "Fleet Management",
    "Guide": "Prof. Hardik Joshi",
    "Mail": "suyashmalik63@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/suyash-a-malik-096805165/",
    "Report": "https://docs.google.com/document/d/1H8z13i6rca-YZmpaM7tuYBTXXtohDtagWrEc8dLA0jA/edit",
    "Tools": "Oracle Fusion, Oracle Jdeveloper",
    "Nature": "Product Developement",
    "Website": "https://www.evosysglobal.com/",
    "Description": "Aims To Reduce The Manual Workload Of Requesting Vehicles, Tracking The Employee Requests And Allocating Through The One Step Solution.",
    "Company": "Evolutionary Systems Pvt. Ltd"
    },
    {
    "Roll": "18BEC114",
    "Name": "Tanmay Jain",
    "Project": "Data Analytics And Business Intelligence",
    "Guide": "Prof. Rachna Sharma",
    "Mail": "jaintanmay102@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/tanmay-jain-39b080172/",
    "Report": "https://docs.google.com/document/d/1Hh-qDvMDntvk0HQrHWEMqIPE7YA7ojVQd5D_gJIqxFU/edit?usp=sharing",
    "Tools": "Spark Sql, Linux, Python, Tableau",
    "Nature": "Product Developement",
    "Website": "https://www.zs.com/",
    "Description": "Working For A Mid Sized Pharma Company In The Following Fields: 1. Designing Algorithm For Targeting A Particular Group Of Health Care Professionals (Hcps) 2. Marketing Analytics 3. Sales Strategy",
    "Company": "Zs Associates India Pvt. Ltd."
    },
    {
    "Roll": "18BEC115",
    "Name": "Riya Dilipbhai Tanna",
    "Project": "Latch Configuration Generation System Using Gan",
    "Guide": "Dr Vaishali Dhare",
    "Mail": "tanna.riya03@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/riyatanna/",
    "Report": "https://docs.google.com/document/d/1PW1GzWGXYbsdURVB8eN1uSVbhCr7IVEsVMfKjz3XL98/edit?usp=sharing",
    "Tools": "Ibmeda, Python, Tcl, Unix",
    "Nature": "Experimentation",
    "Website": "https://www.ibm.com/in-en",
    "Description": "To Learn Config Embedding For Each Lcb And Predict Parameters Like Qor, Wace, Wl, Etc. Gan With Encoder-Decoder Architecture Will Be Used To Improve The Parameters And Generate New Config Embedding For Each Node. ",
    "Company": "Ibm"
    },
    {
    "Roll": "18BEC116",
    "Name": "Thakkar Anisha Arvindbhai",
    "Project": "Smart Asset Tracking",
    "Guide": "Dr Usha Mehta",
    "Mail": "anishathakkar912@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/anisha-thakkar-a08971179/",
    "Report": "https://docs.google.com/document/d/1UPpaJRUhPSXmmWSUN3AW_gvNj9aLc_ZwzWgz01UxL8U/edit?usp=sharing",
    "Tools": "Stm32 Kit, Ble Beacons, Mobile Application, Azure Cloud",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/",
    "Description": "Iot And Mcu Based Project, Where I Have Been Assigned In The Iot Part And Cloud Part",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC117",
    "Name": "Kaushik Chandubhai Thumar",
    "Project": "Circuit Design",
    "Guide": "Dr Dhaval Shah",
    "Mail": "thumarkaushik19@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/thumarkaushik19/",
    "Report": "https://drive.google.com/drive/folders/12CyWAWGlsrk5fM2niyYt7yj_BZdhujHh?usp=sharing",
    "Tools": "Viewmate, Algo Pcb Viewer",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com/",
    "Description": "Design Circuit In Software And Hardware Using Different Components Like Resister, Inductor, Capasitor.",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC118",
    "Name": "Toshita Sharma",
    "Project": "Motion Capture Detection System",
    "Guide": "Dr Bhupendra Fataniya",
    "Mail": "toshita2000@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/toshita-sharma-79894a1a4",
    "Report": "https://docs.google.com/document/d/1F2hSMvdKCNJAJ-Vkc52N0FkvO9xoR1I3YCHW4L_SMaw/edit?usp=sharing",
    "Tools": "Python",
    "Nature": "Product Developement",
    "Website": null,
    "Description": "Ai In Computer Vision Applications",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC119",
    "Name": "Dehit Hitendra Trivedi",
    "Project": "Recent Trends In Wireless Communication ",
    "Guide": "Dr Yogesh Trivedi",
    "Mail": "dehit.trivedi@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/dehit-trivedi-62a223195/",
    "Report": "https://docs.google.com/document/d/13AKramwL5QNl3G2l2-lVuR5EZtCtPRGmTK81SnA-xms/edit?usp=sharing",
    "Tools": "Labview, Usrp Hardware, Matlab, Python ",
    "Nature": "Research",
    "Website": "nirmauni.ac.in",
    "Description": "The Primary Focus Of The Research Is To Explore The Currents Trends In Wireless Communication, Specifically To Study The Cognitive Radio Spectrum Sensing. ",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "18BEC120",
    "Name": "Vivek Mukeshbhai Vagheswari",
    "Project": "Smart Home Automation Control",
    "Guide": "Dr Usha Mehta",
    "Mail": "vivekvagheswari2000@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vivek-vagheswari-649076199",
    "Report": "https://docs.google.com/document/d/1Txi-3Cw2bVRGr8y1GSicSeeiajDcQpMUA_Ft8V1A8MM/edit?usp=sharing",
    "Tools": "C,Linux",
    "Nature": "Product Developement",
    "Website": "https://www.einfochips.com",
    "Description": "Create A Home Automation Solution Using Wireless Technology",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC121",
    "Name": "Abhay Harshadbhai Vasjariya",
    "Project": "Embedded Engineer Intern",
    "Guide": "Prof. Rutl Patel",
    "Mail": "abhaypatel2672@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/abhay-patel-7a441a1a0",
    "Report": "https://docs.google.com/document/d/1TLAA1tA_Zw_u-Oao5ulboabFnG0ZumapMpX7MqTUr2o/edit?usp=sharing",
    "Tools": "Visual Studio, Pycharm, Rpi Pico",
    "Nature": "Product Developement",
    "Website": "https://www.morphlelabs.com/",
    "Description": "Researching And Optimizing Scanner Systems Performance",
    "Company": "Morphle Labs Private Limited"
    },
    {
    "Roll": "18BEC122",
    "Name": "Vincent Abraham",
    "Project": "Development Of A Portable Ventilator",
    "Guide": "Dr Sachin Gajjar",
    "Mail": "vincent.ahm@gmail.com",
    "Linkedin": "linkedin.com/in/vincent-abraham-0205",
    "Report": "https://docs.google.com/document/d/1KSaAAu_wrguzFU9F6Z9wPFTVwSWDHFjQ/edit?usp=sharing&ouid=112517300424226889263&rtpof=true&sd=true",
    "Tools": "Visual Studio Code, Eagle, Cubeide, C, C++, Python",
    "Nature": "Product Developement",
    "Website": "https://oxvi.life/",
    "Description": "Providing Assistance In The Software & Hardware Design, And Testing Of The Ventilator",
    "Company": "Oxvi"
    },
    {
    "Roll": "18BEC123",
    "Name": "Virag Chiragbhai Shah",
    "Project": "Circuit Design",
    "Guide": "Prof. Jayesh Patel",
    "Mail": "viragcshah@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/viragcshah7585/",
    "Report": "https://docs.google.com/document/d/1b2OThW6OwQfiwhiPrkU3guLskKwkoy6CTRbi-5eYLWI/edit?usp=sharing",
    "Tools": "Eda Softwares, Simulation Software",
    "Nature": "Simulation",
    "Website": "https://www.einfochips.com/",
    "Description": "-",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC124",
    "Name": "Vishwa Chintan Shah ",
    "Project": " Risk Management Component For Stock Exchange",
    "Guide": "Dr Manish Patel",
    "Mail": "Vishwashah40@gmail.com",
    "Linkedin": "http://linkedin.com/in/vishwa-shah-941165132",
    "Report": "https://docs.google.com/document/d/1oHHhjbiVipPiUaum20gqD9EyL3LjvaXV-6ChtiGP3H8/edit?usp=sharing",
    "Tools": "Sql, Excel, Python (Basic)",
    "Nature": "Product Developement",
    "Website": "http://www.mantissainfotech.com/Home",
    "Description": "Uring Your Internship Period, You Will Be Working With The Team Engaged In Development Of Span Equivalent Margining Component. Span Is A Standard Developed By Chicago Mercantile Exchange (Cme) And It Is The Most Widely Adopted Margining Methodology By Stock Exchanges Across The Globe For The Effective Market Wide Risk Management.",
    "Company": "Mantissa Infotech Private Limited"
    },
    {
    "Roll": "18BEC125",
    "Name": "Yadav Ayush Jitendrakumar",
    "Project": "Apfc Control Panel Design For Industrial Application & Power Factor Improvement By Using Apfc Panel",
    "Guide": "Dr Dilip Kothari",
    "Mail": "yadavayush2425@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/ayushyadav- 9912431bb/",
    "Report": "https://docs.google.com/document/d/17YTq4QVM7TGRDfM-PSZjgkQB-cKF_yGJhUvNS9XXrpE/edit?usp=sharing",
    "Tools": "Autocad ",
    "Nature": "Research",
    "Website": "http://www.tajelectrical.com",
    "Description": "Design In Autocad Software, Proposed Method For Industrial Purpose To Improve The Power Factor And Concluded The Power Factor Correction Techniques ",
    "Company": "Taj Electricals"
    },
    {
    "Roll": "18BEC126",
    "Name": "Yash Talesara",
    "Project": "Decision Analytics Associate - Intern",
    "Guide": "Dr Vijay Savani",
    "Mail": "yash1999talesara@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/yash-talesara-7901a1179/",
    "Report": "https://docs.google.com/document/d/138Qqq-BcAxspMwefcN4UrxvRW4cc7RlizvW6cgmJW7A/edit?usp=sharing",
    "Tools": "Ms Excel, R, Python, Ms Access, Tableau, Sql",
    "Nature": "Product Developement",
    "Website": "zs.com",
    "Description": "Data Analysis",
    "Company": "Zs Associates India Pvt. Ltd."
    },
    {
    "Roll": "18BEC127",
    "Name": "Jain Yash Sunderlal",
    "Project": "Smart Home Automation Control",
    "Guide": "Dr Vaishali Dhare",
    "Mail": "yashjain@402@yahoo.com",
    "Linkedin": "https://www.linkedin.com/in/nirmayash/",
    "Report": "https://docs.google.com/document/d/1uAT4pQbH3tbQV58YZdLA0WAoB_5MQlcU1N5eL7YPwRY/edit?usp=sharing",
    "Tools": "Micro Controller Evm, Gateway.",
    "Nature": "Product Developement",
    "Website": "http://www.einfochips.com/",
    "Description": "Create A Home Automation Solution Using Wireless Technology. Home Appliances That Supports Wireless Technology Can Be Connected To A Gateway. Use A Micro Controller Evm As Main Controller & Gateway, Which Will Be Controlled Locally Using Local Hmi And Share Information To The Cloud To Control Appliances Remotely As Well.",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "18BEC128",
    "Name": "Yugank Kulshrestha ",
    "Project": "Pim Implementation",
    "Guide": "Dr Ambika Bhatta",
    "Mail": "hiyugank@gmail.com",
    "Linkedin": "www.linkedin.com/in/yugank-kulshrestha-670a85185",
    "Report": "https://docs.google.com/document/d/1GqdUIUiz-p_Aw3M7CVz_6N7db7rMtOAh/edit?usp=sharing&ouid=111314626852054880667&rtpof=true&sd=true",
    "Tools": "Php",
    "Nature": "Research",
    "Website": "https://www.credencys.com",
    "Description": "From Discovery Stage Of The Client Company To Implementation Of Pim.",
    "Company": "Credencys Solutions Inc."
    },
    {
    "Roll": "18BEC129",
    "Name": "Shivam Kamal Agrawal",
    "Project": "Digigov Framework",
    "Guide": "Prof. Rutl Patel",
    "Mail": "ska18102000@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/shivam-agrawal-83b3581a6",
    "Report": "https://docs.google.com/document/d/1TdKHOzKpoKRPNYpAkFZGqsAtqZ9iR_mMpkrX4VrzJWI/edit?usp=drivesdk",
    "Tools": "Spring Boot, Hibernate, Java",
    "Nature": "Product Developement",
    "Website": "https://www.tcs.com/",
    "Description": "Development Of New Version Of Digigov Framework: Digigov 4.0",
    "Company": "Tata Consultancy Services"
    },
    {
    "Roll": "19BEC502",
    "Name": "Mihir Bhupendrakumar Gandhi",
    "Project": "Multi Million Gates Implementation In Physical Design Or Asic Implementation On Soc Using 28Nm And 16Nm Technology",
    "Guide": "Dr Amisha Naik",
    "Mail": "mihirgandhi.official@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/mihir-gandhi-a9501653",
    "Report": "https://docs.google.com/document/d/1ywifDsjIjZ0O1e5UJxpjH8VmFm4Hy_MhZpESpTsoQv8/edit?usp=sharing",
    "Tools": "Linux, Tcl, Ic Compiler Synopsys Tool, Primetime",
    "Nature": "Experimentation",
    "Website": "https://www.einfochips.com/",
    "Description": "Multi Million Gates Implementation In Physical Design Or Asic Implementation On Soc Using 28Nm And 16Nm Technology ",
    "Company": "Einfochips - An Arrow Company"
    },
    {
    "Roll": "19BEC503",
    "Name": "Hitarth Animesh Bhatt",
    "Project": "Design And Qc Of Furnace Control And Power Systems",
    "Guide": "Dr Amisha Naik",
    "Mail": "hitarth.bhatt@gmail.com",
    "Linkedin": "www.linkedin.com/in/hitarth-bhatt-b87b38230",
    "Report": "https://docs.google.com/document/d/1NVPkNxX5G8KRdVonVF8lWyfG4uEqhIrbd2NICHEm7ec/edit?usp=sharing",
    "Tools": "-",
    "Nature": "Product Developement",
    "Website": "www.electrotherm.com",
    "Description": "Working On The Power Electronics And Control Circuits At Design And Testing Level Along With Electrical Design.",
    "Company": "Electrotherm India Ltd."
    },
    {
    "Roll": "19bec506",
    "Name": "Zain Zuber Khan",
    "Project": "Member Of Product Management Team",
    "Guide": "Dr Yogesh Trivedi",
    "Mail": "zainzuber7@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/zain-khan-358ba416a/",
    "Report": "https://drive.google.com/drive/folders/10BcvfDVqggAgqhI-ugPIxZc_Aa2vumiH?usp=sharin",
    "Tools": "Matrix Proprietary Software And Hardware",
    "Nature": "Product Developement",
    "Website": "https://www.matrixcomsec.com/",
    "Description": "Product Management ",
    "Company": "Matrix Comsec Pvt Ltd"
    },
    {
    "Roll": "19BEC507",
    "Name": "Mekala Rama Krishna Krishna",
    "Project": "Yolo Object Detection",
    "Guide": "Prof. Rutl Patel",
    "Mail": "ramakrishnamekala129@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/ramakrishna-mekala-4a7937a0/",
    "Report": "https://docs.google.com/document/d/1dW4NAV_ws6JbuUP7izMZpcFq2SJNKj0Ej85E-Y6OSX8/edit?usp=sharing",
    "Tools": "Python",
    "Nature": "Experimentation",
    "Website": "https://nirmauni.ac.in",
    "Description": "Experimenting With Yolox",
    "Company": "In House - Nirma University"
    },
    {
    "Roll": "19BEC509",
    "Name": "Dhairyaraj Dharmrajsinh Jadeja",
    "Project": "Pedestrian Dead Reckoning (Pdr)",
    "Guide": "Dr Dhaval Pujara",
    "Mail": "dhairyarajjadeja@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/dhairyarajsinh-jadeja-5722161ab/",
    "Report": "https://docs.google.com/document/d/1WXWfSTns2hdmy60bTXFi0Ks_8TkCDkwtKi-r8RBuiRo/edit",
    "Tools": "Nan",
    "Nature": "Product Developement",
    "Website": "https://www.indiannavy.nic.in/insvalsura/",
    "Description": "The Aim Of The Project Is To Identify The Location Of The Personal Having The Tracker Device And Later With The Help Of Machine Learning Algorithm Such As Richardson'S Extrapolation, We Have To Predict The Entire Route",
    "Company": "Indian Naval Services, Valsura"
    },
    {
    "Roll": "19BEC511",
    "Name": "Sanyam Santosh Pathak ",
    "Project": "Integrated Security Monitoring System",
    "Guide": "Prof. Jayesh Patel",
    "Mail": "sanyampathak17@gmail.com",
    "Linkedin": "www.linkedin.com/in/sanyam-pathak-bb247b1b2 ",
    "Report": "https://docs.google.com/document/d/1MdokTYOqN0XQHkYe4n43zZk3-p6eE9RkLL3pv2_9BYg/edit?usp=sharing",
    "Tools": "Pycharm Community Edition, Python, Opencv, Tesseract-Ocr, Haarcascade Classifier,Face-Recognition Library, Knn Classifier",
    "Nature": "Product Developement",
    "Website": "https://www.indiannavy.nic.in/insvalsura/",
    "Description": "Developing A System Supporting Facial Recognition System And Vehicle Detection System For Authentication And Security Monitoring Applications.",
    "Company": "Indian Naval Services, Valsura"
    },
    {
    "Roll": "18BEC073",
    "Name": "Rahilkumar Mukeshbhai Patel",
    "Project": "Development Based On Php, Laravel",
    "Guide": "Prof. Rachna Sharma",
    "Mail": "rahilpatel2001@gmail.com",
    "Linkedin": "linkedin.com/in/rahil-patel-827703171",
    "Report": "https://docs.google.com/document/d/1eM7Vo5c5V9ZJ3NUYkZvHBczF50RkwNJzL0sS1UNXu24/edit?usp=sharing",
    "Tools": "Php, Laravel",
    "Nature": "Product Developement",
    "Website": "https://netpairinfotech.com/",
    "Description": "Website Development Based On Php/Laravel",
    "Company": "Netpair Infotech"
    },
    {
    "Roll": "18BEC032",
    "Name": "Kavan Apurva Gujarathi",
    "Project": "45 W Ac Driver ",
    "Guide": "Prof. Dipesh Panchal",
    "Mail": "kavan.gujarathi@gmail.com",
    "Linkedin": "www.linkedin.com/in/kavan-gujarathi-52738a171",
    "Report": "https://docs.google.com/document/d/1Ju7y6WqE2YsIO7NVQMmoO6GcMkJkqlIPeGkLcF5_WzE/edit?usp=sharing",
    "Tools": "Altium ",
    "Nature": "Product Developement",
    "Website": "https://www.nessa.in",
    "Description": "Work With The Rnd Team To Design A New Led Driver",
    "Company": "Nessa Illumination Pvt. Ltd."
    },
    {
    "Roll": "18bec076",
    "Name": "Vishal Arvindbhai Prajapati",
    "Project": "Not Given A Particular Project, Have Been Given A Team To Clear Multiple Projects",
    "Guide": "Prof. Jayesh Patel",
    "Mail": "vishalprajapati9601@gmail.com",
    "Linkedin": "https://www.linkedin.com/in/vishal-prajapati-6265a8171",
    "Report": "https://drive.google.com/drive/folders/1c9h7jE4fuYhWfwAhzemMkHcZZyvZz_RJ",
    "Tools": "General Connection Drawings , Autocad",
    "Nature": "Experimentation",
    "Website": "http://flametech.co.in/",
    "Description": "I Have To Visit Multiple Site And Have To Understand From Clients About What Type Of Automation They Need In There Machine.",
    "Company": "Flame Tech Switch Gears"
    }
    ]


    export default winterdata2022;